import { Heading as TipTapHeading } from '@tiptap/extension-heading';

export const Heading = TipTapHeading.extend({
  // Change to ctl + shift from mod + alt which breaks on euro and portuguese keyboards
  addKeyboardShortcuts() {
    return this.options.levels.reduce(
      (items, level) => ({
        ...items,
        ...{
          [`Ctrl-Shift-${level}`]: () =>
            this.editor.commands.toggleHeading({ level }),
        },
      }),
      {}
    );
  },

  // Removing # + space shortcuts
  addInputRules() {
    return [];
  },
});
